import { render, staticRenderFns } from "./docLoan.vue?vue&type=template&id=66d9c8dd&scoped=true"
import script from "./docLoan.vue?vue&type=script&lang=js"
export * from "./docLoan.vue?vue&type=script&lang=js"
import style0 from "./docLoan.vue?vue&type=style&index=0&id=66d9c8dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d9c8dd",
  null
  
)

export default component.exports